import { Transform } from 'class-transformer-global-storage';
export function Trim() {
  return Transform(({
    value
  }) => {
    if (typeof value === 'string') return value.trim();
    return value;
  });
}